import {useEffect, useRef, useState} from "react";
import styles from "../ContactsPage.module.scss";
import {cn} from "@/utils/cn.ts";

interface ContactsMenuProps {
    size?: 'xs' | 'lg';
}

/**
 * Меню страницы контактов
 * @constructor
 */
export const ContactsMenu: React.FC<ContactsMenuProps> = ({size = 'lg'}) => {
    const [arrowClass, setArrowClass] = useState('arrow-up');
    const [containerIsOpen, setContainerIsOpen] = useState(false);
    const isOpenRef = useRef(false);
    const toggleRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        /** Открыть реквизиты */
        const open = () => {
            if (!isOpenRef.current) {
                setArrowClass('arrow-down');
                setContainerIsOpen(true);
            } else {
                setArrowClass('arrow-up');
                setContainerIsOpen(false);
            }
            isOpenRef.current = !isOpenRef.current;
        }

        toggleRef.current?.addEventListener('click', open);

        return () => {
            toggleRef.current?.removeEventListener('click', open);
        }
    }, []);

    return (
        <div className={cn(`contacts-container-${size}`, size === 'xs' && styles.contacts__xs)}>
            <h1 className="contacts-title">Контакты</h1>
            <h2 className="contacts-subtitle">Обращения</h2>
            <div>Если у вас возник вопрос -</div>
            <div>
                <a href="https://api.whatsapp.com/send?phone=79841576629" style={{color: '#ce5e02'}}>напишите
                    нам</a>
            </div>
            <div style={{display: 'flex', minWidth: '90vw'}} className={styles.menuItems}>
                <div style={{width: '25%'}}>
                    <h2 className="contacts-subtitle">Сделать заказ</h2>
                    <div>
                        <a href="mailto:shop.podzamenu@yandex.ru"
                           style={{color: '#ce5e02'}}>shop.podzamenu@yandex.ru</a>
                    </div>
                </div>
                <div style={{width: '25%'}}>
                    <h2 className="contacts-subtitle">Где мой заказ</h2>
                    <div>
                        <a href="mailto:logist.podzamenu@yandex.ru"
                           style={{color: '#ce5e02'}}>logist.podzamenu@yandex.ru</a>
                    </div>
                </div>
                <div style={{width: '25%'}}>
                    <h2 className="contacts-subtitle">Сотрудничество</h2>
                    <div>
                        <a href="mailto:marketing.podzamenu@yandex.ru"
                           style={{color: '#ce5e02'}}>marketing.podzamenu@yandex.ru</a>
                    </div>
                </div>
                <div style={{width: '25%'}}>
                    <h2 className="contacts-subtitle">Возврат товара</h2>
                    <div>
                        <a href="mailto:sklad.podzamenu@yandex.ru"
                           style={{color: '#ce5e02'}}>sklad.podzamenu@yandex.ru</a>
                    </div>
                </div>
            </div>
            <h2 className="contacts-subtitle">
                <div style={{display: 'flex'}}>
                    Реквизиты
                    <div ref={toggleRef}
                         id="toggle_requisites"
                         className={arrowClass}></div>
                </div>
            </h2>
            <div id="requisites" className={cn(styles.requisites, containerIsOpen && styles.requisites__open)}>
                <div>Название: ИП Колесниченко Александр Николаевич</div>
                <div>Руководитель, Ф.И.О.: Колесниченко Александр Николаевич</div>
                <div>Действующий на основании: Свидетельство о государственной регистрации № 321253600087011</div>
                <div>Юридический адрес: 690105, Приморский край, г. Владивосток, ул. Майора Филипова, д. 16, кв.
                    186
                </div>
                <div>Фактический адрес: 690088, Приморский край, г. Владивосток, ул. Снеговая, д. 4, оф. 1</div>
                <div>ИНН: 490801599803</div>
                <div>ОГРНИП: 321253600087011</div>
                <div>Расч. счёт: 40802810420090002134</div>
                <div>Банк Филиал «Хабаровский» АО «Альфа-Банк»</div>
                <div>БИК: 040813770</div>
                <div>Кор. счёт: 30101810745374525104</div>
                <br/>
                <div>Название: ИП Болтенкова Ольга Николаевна</div>
                <div>Руководитель, Ф.И.О.: Болтенкова Ольга Николаевна</div>
                <div>Действующий на основании: Свидетельство о государственной регистрации № 325490000005485</div>
                <div>Юридический адрес: 685007, Магаданская область, г. Магадан, ул. Берзин, д. 27</div>
                <div>Фактический адрес: 690088, Приморский край, г. Владивосток, ул. Снеговая, д. 4, оф. 1</div>
                <div>ИНН: 490913644204</div>
                <div>ОГРНИП: 325490000005485</div>
                <div>Расч. счёт: 40802810720000705173</div>
                <div>Банк ООО "Банк Точка"</div>
                <div>БИК: 044525104</div>
                <div>Кор. счёт: 30101810745374525104</div>
            </div>
        </div>
    );
};
